import { Topic } from '@news-mono/web-common'
import React from 'react'
import { useLocation } from 'react-router'
import { StaticHeroByLine } from '../../commonwealth-games'
import { ThemeOverrider } from '../../themes/ThemeOverrider/ThemeOverrider'
import { getBauhausThemeOverride } from '../../__styling/get-bauhaus-theme-override'
import {
    StyledHeroContainer,
    StyledKicker,
    StyledTeaser,
    StyledTextWrap,
    StyledTitle,
} from '../BauhausHeroCard/BauhausHeroCard.styled'
import { StyledWebLink } from '../BauhausSectionHeader/BauhausSectionHeader.styled'
import {
    StyledStaticMediaImage,
    StyledStaticMediaWrap,
} from './BauhausStaticHeroCard.styled'
export interface SectionHeroCardProps {
    primaryTopic?: Topic
    lastUpdated?: string
    description: string
    logo?: string
    heroImage: string
    byLine: { title: string; linkText: string; linkUrl: string }
    share: { url: string; text: string }
    title?: string
}

export const BauhausStaticHeroCard: React.FC<SectionHeroCardProps> = ({
    primaryTopic,
    lastUpdated,
    description,
    logo,
    heroImage,
    byLine,
    share,
    title,
}: SectionHeroCardProps) => {
    const location = useLocation()
    const themeOverride = getBauhausThemeOverride(location.pathname)

    return (
        <ThemeOverrider override={themeOverride}>
            <StyledHeroContainer>
                <StyledTextWrap>
                    <div>
                        {primaryTopic && (
                            <ThemeOverrider override={themeOverride}>
                                <StyledWebLink to={`/${primaryTopic.id}`}>
                                    <StyledKicker>
                                        {primaryTopic.title}
                                    </StyledKicker>
                                </StyledWebLink>
                            </ThemeOverrider>
                        )}
                        <StyledTitle>{title}</StyledTitle>
                        <StyledTeaser isLanding>{description}</StyledTeaser>
                    </div>
                    <StaticHeroByLine
                        byLine={byLine}
                        share={share}
                        lastUpdated={lastUpdated}
                    />
                </StyledTextWrap>
                <StyledStaticMediaWrap>
                    <StyledStaticMediaImage src={heroImage} />
                </StyledStaticMediaWrap>
            </StyledHeroContainer>
        </ThemeOverrider>
    )
}
